import { textOf } from './carryOverTodos'
import type { JSONContent } from '@tiptap/core'

function parseDoc(json: string | null | undefined): JSONContent | null {
  if (!json) return null
  try {
    const doc = JSON.parse(json) as JSONContent
    return doc.type === 'doc' ? doc : null
  } catch {
    return null
  }
}

function isBlank(node: JSONContent): boolean {
  return node.type === 'paragraph' && textOf(node).trim().length === 0
}

/**
 * Today's note with a quick note added at the end (design 29a, "Note"): the
 * title as its own line, then whatever was written under it. Trailing blank
 * lines in the note are dropped so the new text sits right after the last
 * thing written, and one blank line is left after it for the next.
 */
export function appendToNoteDoc(
  existingJson: string | null | undefined,
  title: string,
  bodyJson?: string | null,
): JSONContent {
  const existing = parseDoc(existingJson)?.content ?? []
  const kept = [...existing]
  while (kept.length > 0 && isBlank(kept[kept.length - 1]!)) kept.pop()

  const added: Array<JSONContent> = []
  const trimmed = title.trim()
  if (trimmed) added.push({ type: 'paragraph', content: [{ type: 'text', text: trimmed }] })
  const body = (parseDoc(bodyJson)?.content ?? []).filter((node) => !isBlank(node))
  added.push(...body)

  return { type: 'doc', content: [...kept, ...added, { type: 'paragraph' }] }
}
